import type { ReactNode } from 'react'
import { cn } from './ui'

/**
 * Ana sayfa fotoğrafları. Kaynak ve üretim notu: public/foto/KAYNAK.md.
 * İki genişlik (800, 1400) WebP; boyutlar sabit ki sayfa yüklenirken zıplamasın.
 */
const ORANLAR = {
  '3:4': { w: 1400, h: 1867 },
  '4:3': { w: 1400, h: 1050 },
  '16:9': { w: 1400, h: 788 },
} as const

export type FotoAdi = 'hero' | 'aidat' | 'kongre' | 'genel-kurul' | 'toplanti' | 'bagis'

export function Foto({
  ad,
  alt,
  oran,
  sizes = '(min-width: 1024px) 560px, 100vw',
  oncelik,
  className,
}: {
  ad: FotoAdi
  alt: string
  oran: keyof typeof ORANLAR
  sizes?: string
  /** Ekranın üstündeki görsel: tembel yükleme yok, yüksek öncelik. */
  oncelik?: boolean
  className?: string
}) {
  const { w, h } = ORANLAR[oran]
  return (
    <img
      src={`/foto/${ad}-1400.webp`}
      srcSet={`/foto/${ad}-800.webp 800w, /foto/${ad}-1400.webp 1400w`}
      sizes={sizes}
      width={w}
      height={h}
      alt={alt}
      loading={oncelik ? 'eager' : 'lazy'}
      decoding="async"
      fetchPriority={oncelik ? 'high' : undefined}
      className={cn('block h-auto w-full object-cover', className)}
    />
  )
}

/** Fotoğraf kartı: yuvarlatılmış, ince çerçeveli; üstüne yüzen kartlar konur. */
export function FotoKart({
  children,
  ustune,
  className,
}: {
  children: ReactNode
  /** Fotoğrafın üstüne konumlanan öğeler (mutlak konumlu). */
  ustune?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('relative', className)}>
      <div className="overflow-hidden rounded-[var(--radius-panel)] ring-soft">{children}</div>
      {ustune}
    </div>
  )
}

/** Fotoğraf üstünde yüzen küçük arayüz kesiti. */
export function YuzenKart({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div
      className={cn(
        'absolute rounded-[var(--radius-card)] bg-surface p-3 text-ink ring-soft backdrop-blur',
        className,
      )}
    >
      {children}
    </div>
  )
}
